var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnfollow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUnfollow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-forums-",
    transform: "translate(-655.000000, -781.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(118.000000, 611.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hot-Topics",
    transform: "translate(0.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MaxForum-Copy-2",
    transform: "translate(21.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-popUp",
    transform: "translate(496.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopUpMenu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(20.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icUnfollow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25 C5.5952381,25 0,19.4047619 0,12.5 C0,5.5952381 5.5952381,0 12.5,0 C19.4047619,0 25,5.5952381 25,12.5 C25,19.4047619 19.4047619,25 12.5,25 Z M12.5,1.19047619 C6.25,1.19047619 1.19047619,6.25 1.19047619,12.5 C1.19047619,18.75 6.25,23.8095238 12.5,23.8095238 C18.75,23.8095238 23.8095238,18.75 23.8095238,12.5 C23.8095238,6.25 18.75,1.19047619 12.5,1.19047619 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 12,
    width: 10,
    height: 1.38888889,
    rx: 0.694444444
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnfollow);
export default __webpack_public_path__ + "static/media/icUnfollow.181b20465722da06a0f9ddcc5ae1f8b1.svg";
export { ForwardRef as ReactComponent };